<template>
    <div class="testOfChoice" v-show="propTestItems.length>0">
        <div class="head">
            <div class="title">
                <div class="mainTitle" :class="{'is-hpnk': isHpnk}">{{ isHpnk ? '妈妈焦虑程度测评' : '' }}</div>
                <!--<p class="secTitle">为你精心挑选的专业测评</p>-->
            </div>
            <div v-if="!isHpnk" class="more fs-14">
                <v-touch @tap="toSorts" class="more-text">更多</v-touch>
            </div>
        </div>
        <div class="container">
            <v-touch @tap="toTestDetail(item)" tag="li" v-for="item in propTestItems" :key="item.scalePoolId">
                <testItem class="testItem" :item="item"></testItem>
            </v-touch>
        </div>
    </div>
</template>

<script>
    import testItem from '../../common/testItem.vue'
    export default {
        name: 'showIndexTestOfChoice',
        components: {
            testItem,
        },
        props: {
            propTestItems: {
                required: true,
                type: Array,
                default: () => {
                    []
                }
            }
        },
        methods: {
            toSorts: function () {
                const that = this;
                that.$router.push({
                    name: 'sorts',
                    path: '/sorts',
                    query: {
                        channelId: that.channelId,
                    }
                })
            },
            toTestDetail(testObj) {
                this.$emit('testClick', testObj)
                // 微站-测评大厅-查看精选测评 神策埋点
                this.$wechatTrackEvent('weizhan_cepinghome_checkchosentest', {
                    test_id: testObj.scalePoolId,
                    test_name: testObj.name,
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../scss/function';

    .testOfChoice {
        // border-bottom: topx(1rem) solid #DDDDDD;
        .head {
            display: flex;
            padding: topx(30rem) topx(40rem) topx(20rem) topx(40rem);
            align-items: center;
            .title {
                flex: 1 1 0;
            }
            .more {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                width: topx(160rem);
                /* font-size: 14px; */
                line-height: 1.1;
                /* height: topx(30rem); */
                color: #333;
                border-radius: topx(26rem);
                &-text {
                    position: relative;
                    padding-right: topx(20rem);
                    margin-top: topx(-2rem);
                    &:before {
                        content: '';
                        position: absolute;
                        right: topx(2rem);
                        top: 50%;
                        transform: translate(0, -50%);
                        display: block;
                        width: topx(10rem);
                        height: topx(20rem);
                        background: url('../../../assets/icon/icon_arrow_r.svg') no-repeat center;
                        background-size: cover;
                    }
                }
            }
        }
        .mainTitle {
            width: topx(184rem);
            height: topx(43rem);
            color: #4C4B58;
            /*margin-bottom: topx(10rem);*/
            background: url('../../../assets/show/indexTitle/indexTitle_choice.png') no-repeat;
            background-size: cover;

            &.is-hpnk {
                width: auto;
                line-height: topx(43rem);
                background: none;
                font-size: topx(36rem);
                font-weight: 600;
                color: #333;
            }
        }
        .secTitle {
            font-size: 10px;
            color: #999999;
            line-height: 1;
        }
        .container {
            li {
                &:last-child {
                    .testItem {
                        border-bottom: 0;
                    }
                }
                .testItem {
                    margin-left: topx(30rem);
                    margin-right: topx(30rem);

                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/show/index/testsOfChoice.vue